/**
 * 聊天会话右侧功能合并组件
 * @author sunzhiguang
 * @date 2020/6/16
 */

import React from "react";
import "./index.less";
import GroupHead from "@/components/chat/GroupHead";
import SessionSetting from "@/components/chat/SessionSettingV2";
import GroupMembers from "@/components/chat/GroupMembersV2/index";
import GroupOperation from "@/components/chat/GroupOperation";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import SessionRecordSearch from "@/components/chat/MessageHistorySearch";
import { DrawTypeEnum } from "@/components/chat/enum";
import GroupTagList from "@/components/Projects/pages/groupTag";
import GroupRecordClean from "@/components/chat/SessionSetting/GroupRecordClean";
import SettingClose from "@/assets/svg/setting_close.svg";
import { Divider} from "antd";
import IconFont from "@/components/icon";

interface Props {
  openSetup: boolean;
  historySearchOpen: boolean;
  shareJoyspaceOpen: boolean;
  userData: any;
  session?: any;
  onToggleSetup?: (type: DrawTypeEnum) => void;
  onClickClose?: () => void;
}

type IProps = Readonly<Props & ChatState>;

function ChatRight(props: IProps) {
  const {
    openSetup,
    historySearchOpen,
    shareJoyspaceOpen,
    sessionMembers,
    selectedSession,
    onClickClose,
    session,
    onToggleSetup
  } = props;
  if (!selectedSession.sessionId) {
    return <div />;
  }
  const handleSettingCloseClick = () => {
    if(onToggleSetup){
      onToggleSetup(DrawTypeEnum.setup)
    }
  }

  return (
    <div className="chat-right-container">
      <div className="change-set" id="chat-right-container-change-set">
        <div className="change-set-box">
          {/* 设置文案 and 关闭按钮 */}
          <div className="change-set-box-top">
            <div className="change-set-box-title">设置</div>
            <div className="change-set-box-close" onClick={handleSettingCloseClick}>
               <IconFont type="iconguanbi" />
            </div>
           
          </div>
          {/* 龙芯浏览器bug处理：默认不把‘右侧设置栏’挂入dom树（原来是挂在dom树但默认不显示- width为0），改动后的效果就是：右侧设置栏的更新 变为 创建 */}
          <div className="change-set-box-body">
            {openSetup ? (
            <>
              <GroupHead />
               {selectedSession.isGroup && <GroupMembers />}
              {/* <Divider style={{margin: "0 auto", color: "#DBDBDC99", width: "90%", minWidth: "90%"}} /> */}
              <SessionSetting
                newSession={session}
                sessionMembers={sessionMembers}
                openSetup={openSetup}
              />
              <Divider style={{margin: "0 auto", color: "#DBDBDC99", width: "90%", minWidth: "90%"}} />
              {selectedSession.isGroup && <GroupOperation />}
            </>
          ) : null}
          </div>
          <SessionRecordSearch historySearchOpen={historySearchOpen} onClickClose={onClickClose} />
          <GroupTagList />
          {selectedSession.isGroup && <GroupRecordClean />}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  const { sessionMembers, selectedSession } = chat as ChatState;
  return { sessionMembers, selectedSession };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatRight);
